module.exports = "/icon-lg-compliance.svg?cd5667";